<!--
 * @Author: lan.h
 * @Date: 2022-04-07 09:35:57
 * @LastEditors: lan.h
 * @LastEditTime: 2022-04-08 10:01:28
 * @Description: 引导页
-->
<template>
  <div class="guide" v-if="is_show">
    <div class="guide-content">
      <div><img :src="imgArr[0]"></div>
      <div>
        <img class="left" :src="imgArr[1]">
        <div class="right">
          <h1>动脉网改版啦！</h1>
          <div class="desc">
            <p>全新 “<span>数据产品</span>” 服务上线，更多赛道 / 公司 / 快讯 / 专题Pro / 数据库信息欢迎查看。还有更加智能的图表报告欢迎体验。</p>
            <div class="btn" @click="setGuide">我知道了</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadImgEnd } from 'js/utils'
export default {
  data() {
    return {
      is_show: false,
      imgArr: [
        this.$store.state.static_img_url + 'pic/vcbeat/guide_nav.png',
        this.$store.state.static_img_url + 'pic/vcbeat/guide.png'
      ]
    }
  },
  created() {
    if(!window.localStorage.getItem('guide')){ 
      this.getGuide()
    }
  },
  methods: {
    getGuide() {
        loadImgEnd(this.imgArr, ()=>{
          this.is_show = true
          document.documentElement.style.overflowY = 'hidden'
        })
    },
    setGuide() {
      this.is_show = false
      document.documentElement.style.overflowY = 'auto'
      // window.localStorage.removeItem('guide')
      window.localStorage.setItem('guide', 1)
    }
  }
}
</script>

<style lang="stylus" scoped>
.guide
  width 100vw
  height 100vh
  background rgba(0, 0, 0, 0.4)
  position fixed
  top 0
  left 0
  right 0
  z-index 2000
  &-content
    width 1200px
    height 100%
    margin 0 auto
    position relative
    >div:nth-child(1)
      top 6px
      position absolute 
      left 226px
      img 
        width 145px
    >div:nth-child(2)
      top 240px
      position absolute 
      left 226px
      background #FFFFFF
      display flex 
      justify-content space-between
      border-radius 30px
      align-items center
      .left
        border-radius 30px
        width 168px
      .right 
        width 258px
        padding 20px 20px 20px 0
        font-family PingFang SC
        h1 
          font-size 16px
          font-weight 500
          color #333333
          line-height 1
          text-align center
        .desc
          p
            font-size 14px
            font-weight 400
            color #333333
            line-height 22px
            margin-top 10px
            text-align justify
            span 
              color rgba(255, 136, 36, 1)
          .btn
            background #ff8824
            box-shadow 0px 4px 10px 0px rgba(255, 108, 55, 0.4)
            border-radius 14px
            width 100px
            color #fff
            font-size 14px
            line-height 28px
            text-align center
            float right
            clear both
            cursor pointer
            &:hover
              transition all 0.5s
              background #ffa75c
      &::before
        position absolute
        content ''
        width 0
        height 0
        border-left 12px solid transparent
        border-right 12px solid transparent
        border-bottom 20px solid #fff
        top -20px
        left 30px
</style>